export default "__VITE_ASSET__Cnng_vLu__"